import { ANNOUNCEMENT_AUDIENCE_QUERY_TYPES } from "./announcementUtils";

export const RETAILER_ANNOUNCEMENT_USER_TYPES = ["national", "branch", "store"];

export const canViewAnnouncementInbox = (userDetail) => Boolean(userDetail);

export const announcementAudienceTypeForUser = (userDetail) => {
  const userType =
    userDetail && typeof userDetail.user_type === "string" ? String(userDetail.user_type).trim().toLowerCase() : "";

  if (userType === "") {
    return "";
  }

  if (RETAILER_ANNOUNCEMENT_USER_TYPES.indexOf(userType) !== -1) {
    return "retailer";
  }

  if (ANNOUNCEMENT_AUDIENCE_QUERY_TYPES.indexOf(userType) !== -1) {
    return userType;
  }

  return "";
};
